// **** Generated File: Do NOT edit!  **********
// Generated from java class: com.abinitio.webcommons.abweb.dto.inputargs.FlagsFilterValue
// using template webcommons/abinitio/build/codegen/src/main/resources/tsTemplates/TSClass.vm

import { FilterValue } from "abweb/dto/inputargs/FilterValue";
export class FlagsFilterValueBase extends FilterValue {
  /** Do NOT invoke directly, instead use strongly typed createFlagsFilterValueBase factory method */
  constructor() {
    super();
  }

  // @ts-ignore: noUnusedLocals
  getJavaClass() {
    return "cawadi.FlagsFilterValue";
  }
  initFromJson(json, deserializeContext) {
    this.initFlagsFilterValue(json.componentGuid != null ? json.componentGuid : null, json.selectedFlagIDs != null ? json.selectedFlagIDs : null);
  }
  initFlagsFilterValue(componentGuid, selectedFlagIDs) {
    this.initFilterValue(componentGuid);
    this._selectedFlagIDs = selectedFlagIDs;
  }
  toTSOG(result, serializeContext) {
    const retVal = super.toTSOG(result, serializeContext);
    retVal["selectedFlagIDs"] = this._selectedFlagIDs;
    return retVal;
  }
  get selectedFlagIDs() {
    return this._selectedFlagIDs;
  }
  set selectedFlagIDs(value) {
    this._selectedFlagIDs = value;
  }
}
//# sourceMappingURL=FlagsFilterValueBase.js.map
